export const getTwoProductProperty = (
  productType: string,
  postFixFirst: string,
  secondProductType: string,
  postFixSecond: string
) => {
  let propertyValue = "-";
  if (productType || secondProductType) {
    const firstPart = productType ? productType + postFixFirst : "";
    const secondPart = secondProductType
      ? secondProductType + postFixSecond
      : "";
    propertyValue = [firstPart, secondPart].filter(Boolean).join(", ");
  }
  return propertyValue;
};

export const itemLocation = (item: any) => {
  const city = item?.city || "";
  const state = item?.state || "";
  const country = item?.country || "";

  const locationCityOrState = city || (state !== city ? state : "");
  if (locationCityOrState || country) {
    return [locationCityOrState, country].filter(Boolean).join(", ");
  }
  const location = item?.locations?.[0];
  const locCity = location?.city || "";
  const locState =
    location?.state && location.state !== locCity ? location.state : "";
  const locCountry = location?.country || "";

  const locationString =
    [locCity, locState].filter(Boolean).join("") +
    (locCity || locState ? `, ${locCountry}` : locCountry);

  return locationString || "-";
};
